import { render, staticRenderFns } from "./SearchFilterColors.vue?vue&type=template&id=35060118"
import script from "./SearchFilterColors.vue?vue&type=script&lang=js"
export * from "./SearchFilterColors.vue?vue&type=script&lang=js"
import style0 from "./SearchFilterColors.vue?vue&type=style&index=0&id=35060118&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports